import type { IconSvgObject } from './types';

const ContrastIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12.002", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.9097 18.3695C17.3232 17.265 19 14.8288 19 12.001C19 9.17321 17.3232 6.73703 14.9097 5.63253C13.8893 5.16557 13.3791 4.93208 12.6895 5.37484C12 5.81759 12 6.5454 12 8.00102V16.001C12 17.4566 12 18.1845 12.6895 18.6272C13.3791 19.07 13.8893 18.8365 14.9097 18.3695Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ContrastIcon;
